import { Inject, Injectable } from '@angular/core';
import { CountryRegionRule, Region } from '@shared/models/country-region-rule';
import { COUNTRY_EMAIL_RULES, COUNTRY_REGIONS_RULES } from '@shared/rules/rules-tokens';
import { ShellQuery } from '@shared/store/shell/shell-query';
import { Observable } from 'rxjs';
import { filter, map, shareReplay } from 'rxjs/operators';
import { HostPlatformService } from '@shared/services/host-platform.service';

@Injectable({
	providedIn: 'root'
})
export class AwarenessFacade {
	constructor(
		private readonly shellQuery: ShellQuery,
		@Inject(COUNTRY_REGIONS_RULES) private readonly countries: CountryRegionRule,
		@Inject(COUNTRY_EMAIL_RULES) private readonly countryCodesForEmailNotifications: ReadonlyArray<string>,
		private readonly hostPlatformService: HostPlatformService
	) {}

	region$: Observable<Region | undefined> = this.shellQuery.companyCountryCode$.pipe(
		filter((code): code is string => !!code),
		map(code => this.getRegionByCountryCode(code)),
		shareReplay({ bufferSize: 1, refCount: true })
	);
	shouldNotifyCompanyByEmail$: Observable<boolean> = this.shellQuery.companyCountryCode$.pipe(
		filter((code): code is string => !!code),
		map(code => this.countryCodesForEmailNotifications.includes(code)),
		shareReplay({ bufferSize: 1, refCount: true })
	);
	linkToTheLearningCenter$: Observable<string> = this.region$.pipe(map(region => region?.Link ?? ''));

	isHostPlatformScanner$ = this.hostPlatformService.isScanner$;
	showLearningCenterPart$ = this.isHostPlatformScanner$.pipe(map(isHostPlatformScanner => !isHostPlatformScanner));

	get isProcedureFlow(): boolean {
		return this.shellQuery.isProcedureFlow;
	}

	private getRegionByCountryCode(countryCode: string): Region | undefined {
		return this.countries.Regions.find(region => {
			return region.Countries.find(country => country.Code.toLowerCase() === countryCode.toLowerCase());
		});
	}
}
